// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-bar__provider[data-v-aca3d572]{margin-bottom:5px}.filter-bar__provider__icon[data-v-aca3d572]{display:inline-block;width:50px;height:50px;opacity:.3;margin:10px 5px;transition:opacity .2s ease-in-out}.filter-bar__provider__icon[data-v-aca3d572]:first-child{margin-inline-start:0}.filter-bar__provider__icon.active[data-v-aca3d572]{opacity:1}", ""]);
// Exports
module.exports = exports;
